import invariant from 'invariant';
import isEmpty from 'lodash/isEmpty';
import isFunction from 'lodash/isFunction';
import isString from 'lodash/isString';
import checkStore from './checkStore';
import createReducer from '@project/store/reducers';
var RESET_CONTAINER = 'RESET_CONTAINER';
var createResettableReducer = function (key, reducer) { return function (state, action) {
    if (action.type === RESET_CONTAINER && action.key === key) {
        return reducer(undefined, action);
    }
    return reducer(state, action);
}; };
export function injectReducerFactory(store, isValid) {
    return {
        injectReducer: function injectReducer(key, reducer) {
            if (!isValid)
                checkStore(store);
            invariant(isString(key) && !isEmpty(key) && isFunction(reducer), '(src/utils...) injectReducer: Expected `reducer` to be a reducer function');
            var resettableReducer = createResettableReducer(key, reducer);
            // Check `store.injectedReducers[key] === reducer` for hot reloading when a key is the same but a reducer is different
            if (Reflect.has(store.injectedReducers, key) &&
                store.injectedReducers[key] === resettableReducer)
                return;
            store.injectedReducers[key] = resettableReducer; // eslint-disable-line no-param-reassign
            store.replaceReducer(createReducer(store.injectedReducers));
        },
        resetReducer: function resetReducer(key) {
            store.dispatch({ type: RESET_CONTAINER, key: key });
        },
    };
}
export default function getInjectors(store) {
    checkStore(store);
    return injectReducerFactory(store, true);
}
